export default __webpack_public_path__ + "static/media/switch-camera.dacf1390.svg";